import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBoxOpen,
  faEnvelopeOpen,
  faBox,
  faShare,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import ShareMRPopup from "../RFQ/componenets/ShareRFQPopup"; // Import your existing popup
import AddItemsPopup from "./componenets/AddItemsPopup";
import ViewMRitemsPopup from "./componenets/viewMRItemsPopup"
import { useNavigate } from "react-router-dom";

const MRMaterialsAndResponses = ({ MR, allVendors = [], assignedVendorIds =[], MRDetails, MRItems, fetchMrItems, setPopupType, setMRItemsPoupMessage, setShowPopup}) => {
  const navigate = useNavigate()
  const [isShareOpen, setIsShareOpen] = useState(false);
  const [isAddItemPopupOpen, setIsAddItemPopupOpen] = useState(false);
  const [isViewItemsPopupOpen, setIsViewItemsPopupOpen] = useState();
  const [mrItem , setMrItem] = useState()
  if (!MR) {
    return <div className="text-gray-500">No MR selected.</div>;
  }

    const handleAddMaterialList = () => {
    setIsAddItemPopupOpen(true);
  };

  const handleViewMRitemspopup = (MRItems)=>{
    setMrItem(MRItems)
    setIsViewItemsPopupOpen(true)   
  }

  console.log("MR:---",MR)
 const handleNavigateToRfqDetails = (rfqId) => {
  //navigate('/bb/app/rfq/rfqrequirements', { state: { rfq_id: rfqId } });
  navigate('/bb/app/rfqfullfillmentflow', { state: { rfq_id: rfqId } });
};

  const handleSendRfqToCustomer = async (rfqId) => {
    if (!rfqId) return;

    const customerId = MR?.customer?._id || MR?.customer_id || MR?.customer?.id || MR?.customerId;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/material-requirement/send-rfq-to-customer`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
          },
          body: JSON.stringify({ customerId, rfqId }),
        }
      );

      const result = await response.json().catch(() => ({}));

      if (!response.ok) {
        const message = result.message || "Failed to send RFQ to customer";
        console.error("Failed to send RFQ to customer", result);
        setMRItemsPoupMessage(message);
        setPopupType("400");
        setShowPopup(true);
        return;
      }

      setMRItemsPoupMessage("RFQ sent to customer successfully");
      setPopupType("200or201");
      setShowPopup(true);
      console.log("RFQ sent to customer successfully", result);
    } catch (error) {
      console.error("Error sending RFQ to customer", error);
      setMRItemsPoupMessage("Error sending RFQ to customer");
      setPopupType("400");
      setShowPopup(true);
    }
  };

  const hasQuotations = MR.quotation_ids?.length > 0;

  return (
  <div className="space-y-4 mb-10">
    {/* Customer Materials Section */}
    {(MR.material_list_attachments?.length > 0 ) ? (
      <div>
        <div className="flex justify-between items-center mb-3">
          <h3 className="text-lg font-semibold text-gray-800">
            Customer Material Requirements
          </h3>

          {/* Action Buttons */}
          {MR.status !== "Cancled"  && (
           <button
  type="button"
  onClick={handleAddMaterialList}
  className="flex items-center gap-1 text-sm text-[#f7525a] hover:text-[#f7525a] font-medium"
>
  <FontAwesomeIcon icon={faPlus} /> Add MR items
</button>

          )}
        </div>

        {/* Material Requirements Images (Always show if available) */}
        {MR.material_list_attachments?.length > 0 && (
          <div className="flex flex-nowrap overflow-x-auto gap-4 pb-2 scrollbar-hide">
            {MR.material_list_attachments.map((mat, idx) => (
              <div
                key={idx}
                className="bg-white shadow-sm rounded-lg p-1 flex-shrink-0 w-36"
              >
                <div className="w-34 h-30 flex items-center justify-center bg-gray-50 rounded overflow-hidden relative">
                  {mat ? (
                    <img
                      src={process.env.REACT_APP_FORE_BRICKBUCKET + mat.uri}
                      alt="Material"
                      className="max-h-full max-w-full object-contain"
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.nextSibling.style.display = "flex";
                      }}
                    />
                  ) : null}
                  <FontAwesomeIcon
                    icon={faBox}
                    className="h-8 w-8 text-gray-400 absolute inset-0 m-auto hidden"
                    aria-hidden="true"
                  />
                </div>
              </div>
            ))}
          </div>
        )}

       {/* Requirements - Only for Quick Quotes */}
{/* {!MR.MR_for_project && MRDetails && (
  <div className="mt-4 space-y-3">
    {Array.isArray(MRDetails.requirements) && MRDetails.requirements.length > 0 ? (
      MRDetails.requirements.map((req) => (
        <div
          key={req._id}
          className="bg-white shadow-sm rounded-lg p-3 flex flex-col"
        >
         
          <div className="flex justify-between items-center">
            <p className="text-sm font-medium text-gray-800">
              {req.quotation_number} - {req.quotation_type}
            </p>
            <p className="text-sm font-bold text-gray-800">
              {req.status || "N/A"}
            </p>
          </div>

         
          <p className="text-sm text-gray-700 mt-1">
            Sub Total: ₹{req.subtotal ?? 0}
          </p>
        </div>
      ))
    ) : (
      <div className="text-center text-sm text-gray-500">
        No requirements available for this Material Requirement 
      </div>
    )}
  </div>
)} */}


      </div>
    ) : (
      <div className="bg-white shadow-sm rounded-lg p-6 text-center border border-gray-200">
        <FontAwesomeIcon
          icon={faBoxOpen}
          className="h-12 w-12 text-gray-300 mx-auto mb-3"
          aria-hidden="true"
        />
        <p className="text-sm text-gray-500">
          No material requirements provided by the customer.
        </p>
      </div>
    )}
    
    {MRItems?.length > 0 ? (
  <div className="mt-4">
    <h4 className="text-lg font-semibold text-gray-800 mb-3">Material Requirement Items</h4>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {MRItems.map((item, idx) => (
        <div
          key={idx}
          className="bg-white border border-gray-200 rounded-2xl p-5 shadow hover:shadow-lg transition duration-200 flex flex-col justify-between"
        >
          <div>
            {/* Categories */}
            {Array.isArray(item.product_category_ids) && item.product_category_ids.length > 0 && (
              <div className="mb-3">
                <p className="text-sm font-semibold text-gray-700 mb-1">Categories:</p>
                <div className="flex flex-wrap gap-2">
                  {item.product_category_ids.map((cat, i) => (
                    <span
                      key={i}
                      className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded-full"
                    >
                      {cat.product_category_name}
                    </span>
                  ))}
                </div>
              </div>
            )}

            {/* Price Eligibility */}
            {item.price_eligibility && (
              <p className="text-sm text-gray-700 mb-1">
                <span className="font-semibold">Price Type:</span> {item.price_eligibility}
              </p>
            )}

            {/* Total Items */}
            <p className="text-sm text-gray-700 mb-1">
              <span className="font-semibold">Total Items:</span> {item.total || 0}
            </p>

            {/* RFQ Number */}
            {(item.rfq_number || MR?.rfq_number || MR?.rfq?.rfq_number) ? (
              <div className="flex items-center gap-2">
                <p
                  className="text-sm font-semibold text-gray-700 cursor-pointer"
                  onClick={() => handleNavigateToRfqDetails(MR?.rfq?._id || item.rfq_id || MR?.rfq_id)}
                >
                  RFQ : <span className="text-green-600 underline">{item.rfq_number || MR?.rfq_number || MR?.rfq?.rfq_number}</span>
                </p>
                <button
                  type="button"
                  onClick={() => handleSendRfqToCustomer(MR?.rfq?._id || item.rfq_id || MR?.rfq_id)}
                  className="p-1.5 rounded-full bg-green-50 text-green-600 hover:bg-green-100 transition"
                  title="Send RFQ to customer via WhatsApp"
                >
                  <FontAwesomeIcon icon={faPaperPlane} className="h-4 w-4" />
                </button>
              </div>
            ) : (
              <p className="text-sm font-semibold text-yellow-600">No RFQ created yet</p>
            )}

          </div>

          {/* View Items Button */}
        <div className="mt-4 w-full flex justify-center">
  <button
    onClick={() => handleViewMRitemspopup(item)}
    className="text-sm font-medium py-2 px-4 rounded-md border border-[#f7525a] text-[#f7525a] bg-white hover:bg-[#f7525a] hover:text-white transition-colors duration-200"
  >
    View Items
  </button>
</div>

        </div>
      ))}
    </div>
  </div>
) : (
  // Empty State
  <div className="bg-white border border-dashed border-gray-300 p-8 rounded-2xl text-center mt-6">
    <p className="text-gray-600 text-sm mb-4">
      No Material Requirement items have been added for this requirement yet.
    </p>
    <button
      onClick={handleAddMaterialList}
      className="px-6 py-2 bg-blue-600 text-white text-sm rounded-xl hover:bg-blue-700 transition"
    >
      Add MR Items
    </button>
  </div>
)}




    {/* Share Popup */}
    <ShareMRPopup
      isOpen={isShareOpen}
      onClose={() => setIsShareOpen(false)}
      MR={MR}
      vendors={allVendors}
      assignedVendorIds={assignedVendorIds}
    />

       <AddItemsPopup
        isOpen={isAddItemPopupOpen}
        onClose={() => {
  setIsAddItemPopupOpen(false);
  
  // Close showPopup after 2 seconds
  setTimeout(() => {
    setShowPopup(false);
  }, 2000);
}}
        MRDetails={MR}
        setMRItemsPoupMessage = {setMRItemsPoupMessage}
        setPopupType= {setPopupType}
        fetchMrItems = {fetchMrItems}
        setShowPopup= {setShowPopup}
      />
      
     <ViewMRitemsPopup
        isOpen={isViewItemsPopupOpen}
        onClose={() => {
  setIsViewItemsPopupOpen(false);
  
  // Close showPopup after 2 seconds
  setTimeout(() => {
    setShowPopup(false);
  }, 2000);
}}
        MRDetails={MR}
        MRitem= {mrItem}
        setMRItemsPoupMessage = {setMRItemsPoupMessage}
        setPopupType= {setPopupType}
        fetchMrItems = {fetchMrItems}
        setShowPopup= {setShowPopup}
      />
      
  </div>
);

};

export default MRMaterialsAndResponses;
